import { render, staticRenderFns } from "./BricmateQuantityPicker.vue?vue&type=template&id=6f383aba&"
import script from "./BricmateQuantityPicker.ts?vue&type=script&lang=ts&"
export * from "./BricmateQuantityPicker.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports